namespace GeniuzPOS.Purchase {
    export class PoShipAddressColumns {
        static columnsKey = 'Purchase.PoShipAddress';
    }
}
